import { useI18n as useI18nOriginal } from 'vue-i18n';
import en from './locales/en.json';
import ja from './locales/ja.json';
import zh from './locales/zh.json';
export const messages = {
    en,
    ja,
    zh,
};
export const AVAILABLE_LOCALES = [
    { code: 'en', name: 'English', nativeName: 'English' },
    { code: 'ja', name: 'Japanese', nativeName: '日本語' },
    { code: 'zh', name: 'Chinese', nativeName: '中文' },
];
export const datetimeFormats = {
    en: {
        short: {
            year: 'numeric', month: 'short', day: 'numeric'
        },
        long: {
            year: 'numeric', month: 'short', day: 'numeric',
            weekday: 'short', hour: 'numeric', minute: 'numeric'
        }
    },
    ja: {
        short: {
            year: 'numeric', month: 'short', day: 'numeric'
        },
        long: {
            year: 'numeric', month: 'short', day: 'numeric',
            weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: true
        }
    }
};
export function getI18nConfig(defaultLocale) {
    return {
        legacy: false,
        locale: defaultLocale,
        fallbackLocale: 'en',
        messages,
        globalInjection: true,
        datetimeFormats
    };
}
export function useI18n(options) {
    return useI18nOriginal(options);
}
